<template>
  <v-select
    label="Supplier Type"
    :items="supplierTypes"
    v-model="selectedSupplierTypes"
    clearable
    @change="onInput"
    @click:clear="onClear"
    :outlined="outlined"
    multiple
    :hide-details="hideDetails"
    :dense="dense"
  ></v-select>
</template>

<script>
import SupplierType from "../SupplierType";
import { SUPPLIER_TYPES } from "../../../../constants/supplierTypes";

export default {
  name: "SupplierTypeFilter",

  props: {
    filterValue: {
      type: Object,
      default: () => null,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => true,
    },
    hideDetails: {
      type: Boolean,
      default: () => true,
    },
  },

  components: {
    SupplierType,
  },

  data() {
    return {
      supplierTypes: SUPPLIER_TYPES,
      selectedSupplierTypes: this.filterValue
        ? [...this.filterValue.service_type]
        : [],
    };
  },
  watch: {
    filterValue(newVal) {
      if (newVal) {
        this.selectedSupplierTypes = this.filterValue.service_type;
      } else {
        this.selectedSupplierTypes = [];
      }
    },
  },
  methods: {
    onInput(event) {
      if (event) {
        this.$emit("onInput", {
          filter: { service_type: event },
          displayName: "Type",
          displayValue: this.selectedSupplierTypes.join(", "),
        });
        this.$emit("input", [...this.selectedSupplierTypes]);
      }
    },
    onClear(event) {
      this.$emit("onClear", {
        filter: { service_type: event },
        displayName: "",
        displayValue: "",
      });
      this.$emit("input", []);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/list-filters/SupplierTypeMultiFilter.vue